/**
 * Para onde vai o que a camera leu.
 *
 * Modulo puro: nao abre camera, nao navega, nao toca em React. So decide.
 *
 * QUEM DECIDE E O FORMATO, NAO O TEXTO. O codigo da etiqueta tem 8 caracteres
 * de um alfabeto que inclui os digitos 2 a 9 — e um EAN-8 sem nenhum 0 e
 * nenhum 1 (mais ou menos 1 em cada 6) casa com esse formato perfeitamente.
 * Olhar so para o conteudo mandaria a pessoa para uma etiqueta que nao existe
 * em vez da saida de estoque, sem nenhuma pista do motivo.
 *
 * A camera reporta o formato de cada leitura, entao o empate nao precisa ser
 * adivinhado.
 */

import { codigoDeQr } from './enderecoWeb';

// O plugin devolve os VALORES do enum ('QR_CODE', 'EAN_13'), nao as chaves.
// Normalizar em vez de comparar a string crua: `qr_code` !== `qrcode` foi
// exatamente o que mandou toda etiqueta lida no app para a saida de estoque.
// Uma troca de representacao entre versoes do plugin nao pode reabrir isso.
const FORMATO_QR = 'qrcode';

function normalizar(formato) {
  return String(formato || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

/**
 * @param {string} formato  o `format` que o plugin devolveu (ex.: 'QrCode', 'Ean13')
 * @param {string} valor    o conteudo lido
 * @returns {{ tipo: 'etiqueta'|'produto'|'desconhecido', caminho: string|null }}
 */
export function destinoDaLeitura(formato, valor) {
  const bruto = String(valor || '').trim();
  if (!bruto) return { tipo: 'desconhecido', caminho: null };

  if (normalizar(formato) === FORMATO_QR) {
    const codigo = codigoDeQr(bruto);
    // QR de Wi-Fi, PIX ou cartao de visita e QR, mas nao e etiqueta. Mandar
    // isso para a saida geraria uma busca por um "codigo de barras" absurdo.
    if (!codigo) return { tipo: 'desconhecido', caminho: null };
    return { tipo: 'etiqueta', caminho: `/e/${codigo}` };
  }

  // Qualquer outro formato e codigo de barras — inclusive um que o plugin
  // aprenda a ler depois e que nos ainda nao mapeamos. Tratar como produto
  // erra menos que descartar: a pessoa ja apontou a camera para uma embalagem.
  return { tipo: 'produto', caminho: `/saida?codigo=${encodeURIComponent(bruto)}` };
}
